<div class="bg-primary mol-lakas-grid-wrapper" style="">
  <section class="text-white mb-0 pt-5 kosd-mol-lakas-grid-header">
  </section>
  <section class="mb-4 pb-3  text-white mol-lakas-grid-body" style="">
    <div class="container pt-5 pb-5">
      <div class="row pt-4">
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="container">
          <div class="row justify-content-center kosd-mol-lakas-hero-box">            
            <div class="col-12 col-lg-5 px-lg-1 d-flex flex-column header-text">
              <h1 class="bold px-lg-4 visually-hidden">-</h1>
              <!--
  <h3 class="bold px-lg-4">VÁLTS VELÜNK LAKÁSBIZTOSÍTÁST <span>10% KEDVEZMÉNNYEL,</span> ÉS LÉPJ EGYBŐL <span>GOLD SZINTRE!</span></h3>
  <div class="px-lg-4">
    A megkötött lakásbiztosítások után az <strong>1 éves GOLD tagság</strong> mellett <strong>1 millió forintot</strong> is nyerhetsz MOL Group Gift üzemanyagkártyán!
  </div>
              -->
            </div>    
              <div class="col-lg-6">

                <form class="needs-validation position-relative px-lg-5" id="KosdForm" novalidate style="z-index:4;" [formGroup]="formGroup">
                  <div class="bg-primary d-flex flex-column form-box rounded-4">
                    <div class="form-box-form bg-info p-5 text-dark rounded-4 rounded-bottom-0 shadow-lg">
                      <div class="row">
                        <div class="col-12 col-lg-6 pb-4">
                          <div class="bold text-start text-primary h3">
                            Lakásbiztosítás kalkulátor
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12 mb-3">
                          <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 25" width="46" height="25">
                            <title>MOL_MOVE_LOGO-02-ai</title>
                            <defs>
                              <linearGradient id="g1" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(36.833,0,0,24.903,9.102,.104)">
                                <stop offset="0" stop-color="#e2d26c" />
                                <stop offset="1" stop-color="#a78538" />
                              </linearGradient>
                            </defs>
                            <style>
                              .s0 {
                                fill: url(#g1)
                              }

                              .s1 {
                                fill: #fefefe
                              }

                              .s2 {
                                fill: #a78538
                              }

                              .s3 {
                                fill: #a0ce67
                              }

                              .s4 {
                                fill: #ee3f37
                              }
                            </style>
                            <g id="Layer 3">
                              <g id="&lt;Group&gt;">
                                <path id="&lt;Path&gt;" class="s0" d="m39 0.1h-11.6c0.7 0.7 1 1.6 1 2.5 0 0.8 0 3.2-7.2 8.3-3.7 2.7-7.8 4.9-9.4 5.8q-1.6 0.9-2.7 1.1c0 0.6 0 1 0 1.1 0.4 3.4 3.3 6.1 6.9 6.1h23c3.8 0 6.9-3.1 6.9-6.9v-11.1c0-3.8-3.1-6.9-6.9-6.9z" />
                                <g id="&lt;Group&gt;">
                                  <path id="&lt;Compound Path&gt;" class="s1" d="m16.7 16.2h2.2l1 2.2 1.7-2.2h2.2l-1.1 6.3h-2.1l0.5-3.1-1.8 2.2-1.1-2.2-0.5 3.1h-2.1z" />
                                  <path id="&lt;Compound Path&gt;" fill-rule="evenodd" class="s1" d="m26.7 22.6q-0.7 0-1.3-0.3-0.5-0.2-0.9-0.6-0.4-0.5-0.6-1.1-0.1-0.6 0-1.2v-0.1q0.1-0.6 0.5-1.2 0.4-0.6 0.9-1.1 0.5-0.4 1.2-0.7 0.7-0.2 1.4-0.2 0.7 0 1.3 0.2 0.6 0.3 0.9 0.7 0.4 0.4 0.6 1 0.1 0.6 0 1.3-0.1 0.7-0.5 1.3-0.3 0.6-0.9 1-0.5 0.5-1.2 0.7-0.7 0.3-1.4 0.3zm0.4-1.9q0.3 0 0.5-0.1 0.3-0.1 0.5-0.3 0.2-0.2 0.3-0.4 0.2-0.3 0.2-0.5v-0.1q0.1-0.2 0-0.5 0-0.3-0.2-0.5-0.1-0.1-0.3-0.3-0.2-0.1-0.6-0.1-0.2 0-0.5 0.1-0.3 0.2-0.5 0.3-0.2 0.2-0.3 0.5-0.1 0.2-0.2 0.5 0 0.3 0 0.6 0.1 0.2 0.2 0.4 0.1 0.2 0.3 0.3 0.3 0.1 0.6 0.1z" />
                                  <path id="&lt;Compound Path&gt;" class="s1" d="m31.1 16.2h2.3l0.6 3.5 1.9-3.5h2.3l-3.7 6.3h-2z" />
                                  <path id="&lt;Compound Path&gt;" class="s1" d="m38.5 16.2h5.3l-0.3 1.7h-3.3l-0.1 0.7h3.1l-0.3 1.5h-3l-0.2 0.6h3.3l-0.3 1.8h-5.3z" />
                                </g>
                                <g id="&lt;Group&gt;">
                                  <path id="&lt;Path&gt;" class="s1" d="m38.7 13c-3.1 0-5.6-2.5-5.6-5.6 0-3.1 2.5-5.6 5.6-5.6 3.1 0 5.6 2.5 5.6 5.6 0 3.1-2.5 5.6-5.6 5.6z" />
                                </g>
                                <g id="&lt;Group&gt;">
                                  <path id="&lt;Path&gt;" class="s2" d="m41.9 7.9c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m40.9 7.3c-0.3 0-0.5-0.3-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.4 0.2 0.4 0.5 0 0.2-0.2 0.5-0.4 0.5z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m40.9 8.6c-0.3 0-0.5-0.3-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.4 0.2 0.4 0.5 0 0.2-0.2 0.5-0.4 0.5z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m39.8 6.6c-0.2 0-0.4-0.2-0.4-0.4 0-0.3 0.2-0.5 0.4-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.4-0.5 0.4z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m39.8 7.8c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.4 0.4-0.4 0.3 0 0.5 0.2 0.5 0.4 0 0.2-0.2 0.4-0.5 0.4z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m39.8 9.1c-0.2 0-0.4-0.2-0.4-0.4 0-0.3 0.2-0.5 0.4-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.4-0.5 0.4z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m38.8 5.9c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.3 0.4-0.3 0.2 0 0.4 0.1 0.4 0.3 0 0.2-0.2 0.4-0.4 0.4z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m38.8 7.1c-0.2 0-0.4-0.1-0.4-0.3 0-0.2 0.2-0.4 0.4-0.4 0.2 0 0.4 0.2 0.4 0.4 0 0.2-0.2 0.3-0.4 0.3z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m38.8 8.4c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.3 0.4-0.3 0.2 0 0.4 0.1 0.4 0.3 0 0.2-0.2 0.4-0.4 0.4z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m38.8 9.6c-0.2 0-0.4-0.1-0.4-0.3 0-0.2 0.2-0.4 0.4-0.4 0.2 0 0.4 0.2 0.4 0.4 0 0.2-0.2 0.3-0.4 0.3z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m37.8 5.2c-0.2 0-0.3-0.1-0.3-0.3 0-0.2 0.1-0.3 0.3-0.3 0.1 0 0.3 0.1 0.3 0.3 0 0.2-0.2 0.3-0.3 0.3z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m37.8 6.4c-0.2 0-0.3-0.1-0.3-0.3 0-0.1 0.1-0.2 0.3-0.2 0.1 0 0.3 0.1 0.3 0.2 0 0.2-0.2 0.3-0.3 0.3z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m37.8 7.7c-0.2 0-0.3-0.1-0.3-0.3 0-0.2 0.1-0.3 0.3-0.3 0.1 0 0.3 0.1 0.3 0.3 0 0.2-0.2 0.3-0.3 0.3z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m37.8 9c-0.2 0-0.3-0.2-0.3-0.3 0-0.2 0.1-0.3 0.3-0.3 0.1 0 0.3 0.1 0.3 0.3 0 0.1-0.2 0.3-0.3 0.3z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m37.8 10.2c-0.2 0-0.3-0.1-0.3-0.3 0-0.1 0.1-0.3 0.3-0.3 0.1 0 0.3 0.2 0.3 0.3 0 0.2-0.2 0.3-0.3 0.3z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m36.7 4.5c-0.1 0-0.2-0.1-0.2-0.2 0-0.2 0.1-0.3 0.2-0.3 0.2 0 0.3 0.1 0.3 0.3 0 0.1-0.1 0.2-0.3 0.2z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m36.7 5.8c-0.1 0-0.2-0.1-0.2-0.3 0-0.1 0.1-0.2 0.2-0.2 0.2 0 0.3 0.1 0.3 0.2 0 0.2-0.1 0.3-0.3 0.3z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m36.7 7c-0.1 0-0.2-0.1-0.2-0.2 0-0.2 0.1-0.3 0.2-0.3 0.2 0 0.3 0.1 0.3 0.3 0 0.1-0.1 0.2-0.3 0.2z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m36.7 8.3c-0.1 0-0.2-0.1-0.2-0.3 0-0.1 0.1-0.2 0.2-0.2 0.2 0 0.3 0.1 0.3 0.2 0 0.2-0.1 0.3-0.3 0.3z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m36.7 9.5c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.3 0.2-0.3 0.2 0 0.3 0.2 0.3 0.3 0 0.1-0.1 0.2-0.3 0.2z" />
                                  <path id="&lt;Path&gt;" class="s2" d="m36.7 10.8c-0.1 0-0.2-0.1-0.2-0.3 0-0.1 0.1-0.2 0.2-0.2 0.2 0 0.3 0.1 0.3 0.2 0 0.2-0.1 0.3-0.3 0.3z" />
                                </g>
                                <g id="&lt;Group&gt;">
                                  <path id="&lt;Path&gt;" class="s3" d="m24.6 0.1c2.1 0 2.9 1.3 2.9 2.5 0 4.3-12.9 11.5-16.1 13.3-1 0.5-2.2 1-3.1 1-4.6 0-8.2-8-8.2-12.2 0-2.9 1.1-4.6 3.7-4.6z" />
                                  <path id="&lt;Path&gt;" class="s4" d="m7.7 13.6c-2.3-1.3-5.9-4.5-6.4-9-0.2-2 0.4-3.5 2.5-3.5h20.8c1.7 0 1.9 0.9 1.9 1.5 0 0.7-0.6 2.7-6.4 6.8-2.1 1.5-5.2 3.4-7.7 4.6-1.3 0.6-2.6 0.8-4.7-0.4z" />
                                  <path id="&lt;Path&gt;" class="s1" d="m7.2 14.2c-2.2-1.3-5.8-4.4-6.4-9.5-0.1-0.8 0-1.7 0.3-2.4 0.2-0.5 0.5-1 1-1.4-1.1 0.5-1.6 1.7-1.6 3.6 0 3.9 3.5 11.3 7.8 11.3 0.3 0 0.8-0.2 1.5-0.4q-1.2-0.2-2.6-1.2z" />
                                  <path id="&lt;Path&gt;" class="s1" d="m10 2.6h-1.7l-1 2.7v-2.7h-1.7l-1.8 5.6h1.7l0.6-2.5 0.1 2.5h1.1l1-2.5-0.3 2.5h1.7z" />
                                  <path id="&lt;Compound Path&gt;" fill-rule="evenodd" class="s1" d="m14.7 6.6c-0.9 1.4-2.4 2-3.5 1.3-1.1-0.6-1.3-2.3-0.5-3.7 0.9-1.4 2.4-2 3.5-1.4 1.1 0.7 1.3 2.4 0.5 3.8zm-1.8-2.3c-0.5 0-0.9 0.5-1.1 1.1-0.1 0.6 0.2 1.1 0.7 1.1 0.5 0 1-0.5 1.1-1.1 0.1-0.6-0.2-1.1-0.7-1.1z" />
                                  <path id="&lt;Path&gt;" class="s1" d="m15 8.2h1.9l1.3-1.7h-1.2l0.8-3.9h-1.7z" />
                                </g>
                              </g>
                            </g>
                          </svg>
                          <label for="fieldKuponkod" class="form-label text-uppercase strong text-primary small ms-3">MOL Move kuponkód:</label>
                          <input #fieldKuponkod type="text" maxlength="10" autocomplete="off" class="form-control mb-0 text-uppercase" id="fieldKuponkod" name="fieldKuponkod" formControlName="f_kuponkod">
                          <span class="form-label text-uppercase strong text-primary small">Az egyedi kódot a MOL Move applikációban az Ajánlataim menüponton belül, a Partnerajánlatok fül alatt találod.</span>
                          <span class="form-label text-uppercase strong text-primary small">Ha érvényes kód nélkül szeretnéd elindítani a kalkulációt, akkor kattints <a class="link" (click)="tovabb()">ide</a></span>
                        </div>

                        <div class="col-lg-12 mb-3">
                          Új jogszabály szerint 2025. március 01. - március 31. között költségmentesen mondhatod fel korábbi lakásbiztosítási szerződésed. Az újrakötött szerződés pedig 2025. május 1-vel indul majd. Az addig esedékes díjat meg kell fizetned, de ha pl. éves díjat fizettél eddig, a túlfizetésedet a régi Biztosítód visszautalja részedre.
                        </div>

                        <div class="col-lg-12 mb-3 primary-list">

                          <ul class="pl-4 mb-5 mt-3">
                            <li>Használd az egyedi kódodat a kalkuláció során, és egy 1 éves GOLD tagság lesz a jutalmad!</li>
                            <li>1 darab 1 000 000 Ft értékű MOL Group Gift kártya kerül kisorsolásra a szerencsés biztosítottak között a promóció időtartama, 2025 március hónap alatt!</li>
                            <li>A Gránit Házmester lakásbiztosítás tartalmazza a MOL Move ügyfeleknek fejlesztett, egyedi Félretankolás biztosítást* is.</li>
                            <li>Fontos! A promócióban való részvétel <strong>előfeltétele a sikeres biztosításkötés!</strong></li>
                          </ul>

                        </div>


                        <div class="col-md-12 text-center pt-3 mb-5">
                          <button type="submit" class="btn btn-lg rounded-pill btn-outlined-primary" (click)="kalkulalok()">Kalkulálok</button>
                        </div>

                        <div class="col-lg-12" style="font-size: 0.8rem !important">
                          * a Biztosító feltételeiben részletezettek szerint
                        </div>
                      </div>

                    </div>
                  </div>
                </form>

              </div>


              <div class="col-md-12 h1 bold py-5 text-start mt-n5">
                Miért válassz<br>
                <span class="text-secondary">Minket?</span>
              </div>
              <div class="col-md-3 text-md-center d-flex flex-md-column align-items-md-center p-4 shadow-sm rounded-start-4">
                <div class="mb-2" style="width: 75px">
                  <img src="../../../../assets/images/icon-kosd1.svg" class="img-fluid" alt="molmovelakas ajánlatkérés" aria-label="Napi több ezer ajánlatkérés">
                </div>
                <div class="pt-2 ps-3 ps-md-0">
                  <span class="bold text-uppercase h5">Napi több ezer</span><br>
                  <span>ajánlatkérés</span>
                </div>
              </div>
              <div class="col-md-3 text-md-center d-flex flex-md-column align-items-md-center p-4 shadow-sm border-dark">
                <div class="mb-2" style="width: 75px">
                  <img src="../../../../assets/images/icon-kosd2.svg" class="img-fluid" alt="molmovelakas aktív ügyfél" aria-label="350.000 aktív ügyfél">
                </div>
                <div class="pt-2 ps-3 ps-md-0">
                  <span class="bold text-uppercase h5">350.000</span><br>
                  <span>aktív ügyfél</span>
                </div>
              </div>
              <div class="col-md-3 text-md-center d-flex flex-md-column align-items-md-center p-4 shadow-sm border-dark">
                <div class="mb-2" style="width: 75px">
                  <img src="../../../../assets/images/icon-kosd3.svg" class="img-fluid" alt="molmovelakas ügyfélértékelés" aria-label="4,6 / 5 ÉRTÉKELÉS több ezer ügyfélértékelés alapján">
                </div>
                <div class="pt-2 ps-3 ps-md-0">
                  <span class="bold text-uppercase h5">4,6 / 5 ÉRTÉKELÉS</span><br>
                  <span>több ezer ügyfélértékelés alapján</span>
                </div>
              </div>
              <div class="col-md-3 text-md-center d-flex flex-md-column align-items-md-center p-4 shadow-sm rounded-end-4">
                <div class="mb-2" style="width: 75px">
                  <img src="../../../../assets/images/icon-kosd4.svg" class="img-fluid" alt="molmovelakas 15 ÉVE" aria-label="15 ÉVE az Önök szolgálatában">
                </div>
                <div class="pt-2 ps-3 ps-md-0">
                  <span class="bold text-uppercase h5">15 ÉVE</span><br>
                  <span>az Önök szolgálatában</span>
                </div>
              </div>
              <div class="col-md-12 h2 bold py-5 text-start">
                Gyakran ismételt<br>kérdések
              </div>
            </div>
        </div>
      </div>
    </div>

  </section>
</div>
<section class="bg-info pb-5">
  <div class="container pb-5">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="accordion shadow-lg rounded-4" id="accordionGranit">

          <div class="accordion-item bg-light">
            <h2 class="accordion-header ">
              <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse01" aria-expanded="false" aria-controls="collapse01">
                Miről szól a márciusi kampány, meddig mondhatom fel és mikor szűnik meg a szerződésem?
              </button>
            </h2>
            <div id="collapse01" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
              <div class="accordion-body accordion-shadow-lg text-light">
                <div class="small w-75">
                  A 25/2023. (II.1.) Korm. rendelet és a biztosítási tevékenységről szóló törvény 2024. január 1-től hatályos rendelkezései szerint minden év márciusában lehetőség van meglévő biztosításod felülvizsgálatára, felmondására, biztosító váltásra vagy lakásbiztosítás újrakötésre, a biztosítási évfordulótól függetlenül, mindezt plusz költségektől mentesen.<br />Idén a felmondásra 2025.03.01-2025.03.31-e közt van lehetőséged a meglévő szerződés felmondását a jelenlegi biztosítódnak megküldeni. A szerződések egységesen 04.30-ra szűnnek meg, ez az utolsó biztosított nap és eddig kell a díjat is megfizetni. Az új biztosítást - akár itt az oldalunkon – 2025.05.01-i kockázatviselés kezdettel kell megkötnöd, hogy ne maradjon az ingatlanod biztosítás nélkül.
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item bg-light">
            <h2 class="accordion-header ">
              <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse02" aria-expanded="false" aria-controls="collapse02">
                Érhet-e hátrány amiatt, ha felmondom a szerződésem?
              </button>
            </h2>
            <div id="collapse02" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
              <div class="accordion-body accordion-shadow-lg text-light">
                <div class="small w-75">
                  A szerződés felmondása jogszabályi lehetősége minden magyarországi ingatlanbiztosítás szerződőjének, így ezért semmilyen hátrány nem érhet. Amire érdemes figyelni, hogyha valakinek Hitelszerződéshez kapcsolt fedezet van a lakásbiztosításán bejegyezve, akkor azt az újrakötött szerződésen is jeleznie kell, hogy a bankja felé is folyamatos legyen a fedezet igazolása. Magát a fedezet meglétét a Biztosítók egy központi nyilvántartásba lejelentik, így azzal az ügyfélnek nincs külön feladata.
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item bg-light">
            <h2 class="accordion-header ">
              <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse03" aria-expanded="false" aria-controls="collapse03">
                Miért érdemes biztosítást váltani, mik az előnyei a kampánynak?
              </button>
            </h2>
            <div id="collapse03" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
              <div class="accordion-body accordion-shadow-lg text-light">
                <div class="small w-75">
                  A kampánynak nagy előnye, hogy felhívja az ügyfelek figyelmét a lakásbiztosítási szerződésük átnézésére, aktualizálására. Sok olyan szerződés van ma Magyarországon, ami évek óta, akár 10 éve nem került felülvizsgálatra, ugyanakkor az ügyfelek értékei, akár az ingatlan állapota is változott ezalatt. Legyen ez egy felújítás, egy hozzáépítés vagy néhány értékesebb ingóság cseréje, ha nem aktualizáljuk a szerződésünket, az egy kár esetén nagyon sokba kerülhet. Ugyanakkor a ma elérhető fedezetek is sokkal szélesebbek és jóval kedvezőbb díjon elérhetőek, mint akár 5 vagy 10 évvel ezelőtt, így a pénztárcánk miatt is érdemes az aktualizálással foglalkozni.<br />A Házmester Biztosítás egy 2024-ben fejlesztett, a kor követelményeinek mindenben megfelelő, ugyanakkor rugalmas, az ügyfél igényekhez alkalmazkodó termék, mindezt kedvező díjon. Megéri kalkulálni!
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item bg-light">
            <h2 class="accordion-header ">
              <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Hogyan vehetek részt a nyereményjátékban?
              </button>
            </h2>
            <div id="collapse0" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
              <div class="accordion-body accordion-shadow-lg text-light">
                <div class="small w-75">
                  Ha sikeresen megkötöd a biztosítást ezen az oldalon keresztül, automatikusan bekerülsz a sorsolásba. A játékszabályzatot <a class="download" target="_blank" href="{{weboldalDokumentumok}}granit_lakas_nyeremenyjatek_szabalyzat.pdf">ITT</a> találod.
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item bg-light">
            <h2 class="accordion-header ">
              <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Hogyan és mikor kapom meg a GOLD szintet?
              </button>
            </h2>
            <div id="collapse1" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
              <div class="accordion-body accordion-shadow-lg text-light">
                <div class="small w-75">
                  GOLD tagságra azok a MOL Move ügyfelek jogosultak, akik a promóciós időszak alatt Házmester lakásbiztosítást egyedi kóddal kötöttek és az esedékes időszakra vonatkozó biztosítási díjat határidőre rendezték. A tagságot automatikusan aktiváljuk, legkésőbb 2025. június 30-ig.
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item bg-light">
            <h2 class="accordion-header">
              <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Kérdésem van a promócióval, vagy a biztosítással kapcsolatban. Hova fordulhatok?
              </button>
            </h2>
            <div id="collapse2" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
              <div class="accordion-body accordion-shadow-lg text-light">
                <div class="small w-75">
                  A Gránit Biztosító ügyfélszolgálatát keresd a lap alján található elérhetőségek bármelyikén.
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item bg-light">
            <h2 class="accordion-header ">
              <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Mikor és hogyan történik a sorsolás?
              </button>
            </h2>
            <div id="collapse3" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
              <div class="accordion-body accordion-shadow-lg text-light">
                <div class="small w-75">
                  A Szervező megbízásából a Lebonyolító a Nyereményjáték folyamán ill. lezárását követően 1 (egy) darab főnyereményt sorsol ki háromtagú sorsoló bizottság előtt, a véletlenszerűség elvének eleget tevő elektronikus sorsoló program segítségével, közjegyző jelenlétében. A sorsolásra 2025. júnuisában kerül sor a Lebonyolító székhelyén. A sorsolás nem nyilvános. További részletek a <a class="download" target="_blank" href="{{weboldalDokumentumok}}granit_lakas_nyeremenyjatek_szabalyzat.pdf">Nyereményjáték szabályzatban</a>
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item bg-light">
            <h2 class="accordion-header ">
              <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Hogyan és mikor történik a nyertes közzététele, értesítése?
              </button>
            </h2>
            <div id="collapse4" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
              <div class="accordion-body accordion-shadow-lg text-light">
                <div class="small w-75">
                  A nyertes nevét a <a target="_blank" href="https://granitbiztosito.hu/molmovelakas">https://granitbiztosito.hu/molmovelakas</a> weboldalon hirdetjük ki. A nyeremény átadására legkésőbb a Nyereményjáték lezárultát követő 90 nappal kerül sor.
                </div>
              </div>
            </div>
          </div>
          <!--
  <div class="accordion-item bg-light">
    <h2 class="accordion-header ">
      <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
        A nyereményjáték eddigi nyertesei
      </button>
    </h2>
    <div id="collapse5" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
      <div class="accordion-body accordion-shadow-lg text-light">
        <div class="small w-75">
          Január 10. sorsoláson 100.000 Ft-os utalványt nyertek:
          <ul>
            <li>49. hét: Horváth Zoltán</li>
            <li>50. hét: Holozsnyák Nándor</li>
            <li>51. hét: Enyedi László</li>
            <li>52. hét: Farkas Zsolt</li>
          </ul>
          Nyerteseinket emailben értesítettük, nyereményüket postán küldjük meg részükre.<br />Gratulálunk a nyerteseknek!<br />Következő sorsolás a januárban utasbiztosítási szerződést kötő ügyfeleknek: február 05.!
        </div>
      </div>
    </div>
  </div>
    -->
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-light py-5">
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-12">
        <h2 class="text-primary strong mb-5">Ügyfeleink mondták</h2>
      </div>
      <div class="col-lg-12">
        <div class="swiper TestimonialSlider">
          <div class="swiper-wrapper">


            <div class="swiper-slide d-flex flex-column p-3 p-lg-5 border border-light rounded-3 justify-content-between" *ngFor="let adat of ugyfelElegedettsegLista">
              <div class="d-flex">
                <div>
                  <img src="../../../../assets/images/quote.svg" alt="molemovelakas idézőjel">
                </div>
                <div class="ps-3">
                  {{adat}}
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div>
  </div>
</section>
